export default __webpack_public_path__ + "63fb89d3a640661cdc0c0d6b959bf0a9.png";